import { useNavigate, useParams } from "react-router-dom";
import { Box, Card, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import ObservacoesFeitas from "../dlif/observacoesFeitas";
import RelatorioAnalitico from "./producto/relatorioAnalitico";
import ApproveEmiteCertificadoAutorozacao from "./producto/approveEmiteCertificadoAutorozacao";
import { temPermissao } from "../../../utils/permissoes";
import VerifyPermission from "../../../utils/verifyPermission";
import AlertEdit from "../../../utils/alertEdit";


export default function NavLateral({ solicitacaoAnalise, observacoesFeitas, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
  const user = useSelector((state) => state.account.user);
  const { id } = useParams();
  const { produtoId } = useParams();
  const { action } = useParams();
  const navigate = useNavigate();
  // console.log(useParams())

  return (
    <>
      <Card style={{ padding: 20, marginBottom: 20 }}>

        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/controleQualidade/solicitacoesAnalise.svg" alt="img" width={'100%'} />
        </div>


        <br />
        {solicitacaoAnalise?.status === "Emissão da Autorização de Liberação de Lote" ?

          <Typography align="center">
            Estado da solicitação:
            <b>Concluido</b>
          </Typography>
          :
          <Box>
            <Typography align="center">
              Estado da solicitação:
              <b> {solicitacaoAnalise?.status}</b>
            </Typography>

            {/* Aqui será feita a Avaliação Técnica */}
            {solicitacaoAnalise?.status === "Análise" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['controleQualidadeAnalise'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/approve/Autorização para Análise Laboratorial/${id}`)}
                >
                  Encaminhar para Análise Laboratorial
                </Button>

                <Button
                  disabled={!temPermissao(user, ['controleQualidadeAnalise'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Indeferido/${id}`)}
                >
                  Reprovar Solicitação
                </Button>
              </>
            )}


            {solicitacaoAnalise?.status === "Autorização para Análise Laboratorial" && (
              <>
                {/* <Button
                  disabled={(!temPermissao(user, ['controleQualidadeAtribuirAnalistaRevisor']) & !produtoId)}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                // onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/add/analista-e-revisor/${id}`)}
                >
                  Atribuir Analista e Revisor em cada produto
                </Button> */}
                <br />
                <AlertEdit texto={produtoId ?'Produto selecionado':'Atribuir Analista e Revisor para cada produto'} />

                <Button
                  disabled={!temPermissao(user, ['controleQualidadeAtribuirAnalistaRevisor'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Análise/${id}`)}
                >
                  Voltar para Análise
                </Button>
              </>
            )}

            {/* NESTA FASE DEVE EMITIR O RELATORIO ANALITICO. */}
            {solicitacaoAnalise?.status === "Análise da Amostra" && (
              <>
                <VerifyPermission permissions={user?.permissions} permission={'controleQualidadeRelatorioAnalitico'}>
                  <RelatorioAnalitico
                    solicitacaoAnalise={solicitacaoAnalise}
                    avaliacaoAnalitica={avaliacaoAnalitica}
                    setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                  />
                </VerifyPermission>
              
                <AlertEdit severity='info' texto={'Não esqueça de fazer as análises antes de emitir o relatório analítico'} />

                <Button
                  disabled={!temPermissao(user, ['controleQualidadeRelatorioAnalitico'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Autorização para Análise Laboratorial/${id}`)}
                >
                  Voltar para Análise Laboratorial
                </Button>
              </>
            )}


            {/* NESTA FASE DEVE EMITIR O CERTIFICADO E AUTORIZACAO. */}
            {(solicitacaoAnalise?.status === "Análise do Relatório" || solicitacaoAnalise?.status === "Emissão do Certificado") && (
              <>
                <VerifyPermission permissions={user?.permissions} permission={'controleQualidadeEmissaoCertificado'}>
                  <ApproveEmiteCertificadoAutorozacao
                    solicitacaoAnalise={solicitacaoAnalise}
                    avaliacaoAnalitica={avaliacaoAnalitica}
                    setAvaliacaoAnalitica={setAvaliacaoAnalitica} />
                </VerifyPermission>

                <Button
                  disabled={!temPermissao(user, ['controleQualidadeEmissaoCertificado'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Emissão do Relatório Analítico/${id}`)}
                >
                  Voltar para Emissão do Relatório Analítico
                </Button>
              </>
            )}

          </Box>
        }
      </Card>

      {observacoesFeitas.length !== 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}
    </>
  );
}
